module.exports = __webpack_public_path__ + "static/Giant_Cloud-d35a5c814b7378833a9a6bb37f04709c.png";